import { useIntl } from 'react-intl'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { Severity, VulnerabilitySeverityBadge } from '../vulnerability-severity'
import { Link } from '@contrast-security-inc/design-system-typography'
import React from 'react'
import { Badge } from '@contrast-security-inc/design-system-badges'
import { formatEpochToDate } from './cveUtils'
import { styles } from './styles'
import { VulnerabilityReport } from './cve-interfaces'

interface Props {
  vulnerability: VulnerabilityReport
  severityCode: string
}

export function CveDetailHeader({ vulnerability, severityCode }: Props) {
  const intl = useIntl()
  const { name } = vulnerability.cve

  return (
    <div>
      <div className={styles.cveHeaderStyles}>
        <Stack className={styles.cve1}>
          <VulnerabilitySeverityBadge
            severity={Severity.fromName(severityCode.toUpperCase())}
          />
          {vulnerability.cve.name}
        </Stack>

        <div>
          {vulnerability.cve.cisa ? (
            <Badge className={styles.cve0} color={'yellow50'}>
              {intl.formatMessage({
                id: 'title_knownExploit'
              })}
            </Badge>
          ) : null}
        </div>
      </div>

      <Stack className={styles.cve2}>
        <Stack>
          {intl.formatMessage({
            id: 'title_firstSeenInContrast'
          })}
          {vulnerability.cve.firstSeen === 0
            ? intl.formatMessage({
                id: 'title_appImportanceLevelUnknown'
              })
            : formatEpochToDate(vulnerability.cve.firstSeen)}
        </Stack>

        <Stack>
          {intl.formatMessage({
            id: 'title_firstSeenInNvd'
          })}
          {vulnerability.cve.nvdPublished === 0
            ? intl.formatMessage({
                id: 'title_appImportanceLevelUnknown'
              })
            : formatEpochToDate(vulnerability.cve.nvdPublished)}
        </Stack>

        <Stack>
          {intl.formatMessage({
            id: 'title_lastModifiedNvd'
          })}
          {vulnerability.cve.nvdModified === 0
            ? intl.formatMessage({
                id: 'title_appImportanceLevelUnknown'
              })
            : formatEpochToDate(vulnerability.cve.nvdModified)}
        </Stack>

        {vulnerability.cve.cvssScoreSource ? (
          <Stack>
            <span
              className={styles.cvssScoreSource}
              data-testid="cnaCvssScoreSource"
            >
              {intl.formatMessage({
                id: 'title_nvdPublishedCna'
              })}
              <br />
              {vulnerability.cve.cvssScoreSource}
            </span>
          </Stack>
        ) : null}

        <Stack>
          <Link
            isExternal
            font="body"
            className={styles.nvdLink}
            href={`https://nvd.nist.gov/vuln/detail/${name}`}
          >
            {intl.formatMessage({ id: 'title_csvLink' })}
          </Link>
        </Stack>

        <Stack>
          <Link
            isExternal
            font="body"
            className={styles.cveLink}
            href={`https://www.cve.org/CVERecord?id=${name}`}
          >
            {intl.formatMessage({ id: 'title_cveOrg' })}
          </Link>
        </Stack>
      </Stack>
    </div>
  )
}
